import { FIELDS, STYLE_BOX_MODELS } from '../../shared/screener-constants';
const TEXT_CENTER = 'text-center';
const TEXT_RIGHT = 'text-right';
const ALIGN_TOP = 'align-top';
const ALIGN_MIDDLER = 'align-middle';
const ALIGN_BOTTOM = 'align-bottom';
const LARGE = 'Large';
const MID = 'Mid';
const MEDIUM = 'Medium';
const SMALL = 'Small';
const VALUE = 'Value';
const BLEND = 'Blend';
const GROWTH = 'Growth';
const LOW = 'Low';
const HIGH = 'High';
const LIMITED = 'Limited';
const LTD = 'Ltd';
const MODERATE = 'moderate';
const MOD = 'Mod';
const EXTENSIVE = 'Extensive';
const EXT = 'Ext';
const BLANK = '';

// Common selectors
const getSelectors = () => {
  return [
    [false, false, false],
    [false, false, false],
    [false, false, false]
  ];
};

// A function that creates srText arrays based on inputs
const createSrText = (yLabel, xLabel, yValues, xValues) => {
  const output = [];

  yValues.forEach(yValue => {
    const tempArr = [];
    xValues.forEach(xValue => {
      tempArr.push(`includes ${yValue} ${yLabel} and ${xValue} ${xLabel} funds`);
    });
    output.push(tempArr);
  });

  return output;
};

const styleBoxes = () => {
  return {
    [STYLE_BOX_MODELS.EQUITIES]: {
      heading: 'Equities style box',
      selectors: getSelectors(),
      srText: createSrText(
        'size',
        'fund investment style',
        [LARGE, MEDIUM, SMALL],
        [VALUE, BLEND, GROWTH]
      ),
      xLabel: 'Fund Investment Style',
      xDescriptors: [
        { style: BLANK, value: VALUE, srText: VALUE },
        { style: TEXT_CENTER, value: BLEND, srText: BLEND },
        { style: TEXT_RIGHT, value: GROWTH, srText: GROWTH }
      ],
      yLabel: 'Size',
      yDescriptors: [
        { style: ALIGN_TOP, value: LARGE, srText: LARGE },
        { style: ALIGN_MIDDLER, value: MID, srText: MEDIUM },
        { style: ALIGN_BOTTOM, value: SMALL, srText: SMALL }
      ],
      styleBoxSrText: 'You are now on the Equity Style box, it is a 3 by 3 grid with Columns Value, Blend, Growth for Fund Investment Style and Rows Large, Mid, and Small for Size',
      fieldKey: FIELDS.MSTAREQUITYBOXFILTER
    },
    [STYLE_BOX_MODELS.BONDS]: {
      heading: 'Bonds style box',
      selectors: getSelectors(),
      srText: createSrText(
        'Credit Quality',
        'Interest Rate Sensitivity',
        [HIGH, MEDIUM, LOW],
        [LIMITED, MODERATE, EXTENSIVE]
      ),
      xLabel: 'Interest Rate Sensitivity',
      xDescriptors: [
        { style: BLANK, value: LTD, srText: LIMITED },
        { style: TEXT_CENTER, value: MOD, srText: MODERATE },
        { style: TEXT_RIGHT, value: EXT, srText: EXTENSIVE }
      ],
      yLabel: 'Credit Quality',
      yDescriptors: [
        { style: ALIGN_TOP, value: HIGH, srText: HIGH },
        { style: ALIGN_MIDDLER, value: MID, srText: MEDIUM },
        { style: ALIGN_BOTTOM, value: LOW, srText: LOW }
      ],
      styleBoxSrText: 'You are now on the Bonds Style box, it is a 3 by 3 grid with Columns Limited, Moderate, Extensive for Interest Rate Sensitivity and Rows High, Medium, and Low for Credit Quality',
      fieldKey: FIELDS.MSTARBONDBOXFILTER
    }
  };
};

export default styleBoxes;
